// Utility to get the current cursor position within the content-editable div.
export const getCursorPosition = (element: HTMLDivElement | null): number => {
  const selection = window.getSelection();
  if (!selection || selection?.rangeCount === 0 || !element) {
    return 0;
  }
  const preRange = selection.getRangeAt(0).cloneRange();
  preRange.selectNodeContents(element);
  preRange.setEnd(
    selection.getRangeAt(0).startContainer,
    selection.getRangeAt(0).startOffset,
  );
  return preRange.toString().length;
};
